export default function Terms() {
  return (
    <div className="min-h-screen bg-obsidian text-white font-body max-w-3xl mx-auto px-6 py-12">
      <h1 className="font-heading text-3xl font-black uppercase tracking-tight mb-2">Termos de Serviço</h1>
      <p className="text-txt-secondary text-sm mb-8">Última atualização: Maio 2026</p>

      <section className="space-y-6 text-sm text-txt-secondary leading-relaxed">
        <div>
          <h2 className="text-white font-bold text-base mb-2">1. Aceitação dos Termos</h2>
          <p>Ao aceder ou utilizar o BetModel ("Serviço"), concorda em ficar vinculado a estes Termos de Serviço. Se não concordar com alguma parte dos termos, não poderá aceder ao Serviço.</p>
        </div>

        <div>
          <h2 className="text-white font-bold text-base mb-2">2. Descrição do Serviço</h2>
          <p>O BetModel é uma plataforma de análise estatística de futebol que fornece probabilidades calculadas por modelos matemáticos. O serviço destina-se exclusivamente a fins informativos e de entretenimento. Não somos uma casa de apostas e não aceitamos apostas.</p>
        </div>

        <div>
          <h2 className="text-white font-bold text-base mb-2">3. Aviso Legal — Apostas Desportivas</h2>
          <p>As previsões e análises fornecidas pelo BetModel são baseadas em modelos estatísticos e não garantem resultados. As apostas desportivas envolvem risco financeiro. O BetModel não se responsabiliza por quaisquer perdas financeiras resultantes do uso das nossas análises. Aposte com responsabilidade. O jogo pode criar dependência — se tiver problemas com jogo, contacte o Serviço Nacional de Apoio.</p>
        </div>

        <div>
          <h2 className="text-white font-bold text-base mb-2">4. Subscrição Premium</h2>
          <p>O plano Premium custa $9.99 USD por mês. O primeiro mês tem um desconto de 50% ($4.99 USD). A subscrição renova automaticamente. Pode cancelar a qualquer momento através da sua conta. O cancelamento entra em vigor no final do período de faturação atual.</p>
        </div>

        <div>
          <h2 className="text-white font-bold text-base mb-2">5. Restrições de Uso</h2>
          <p>Não pode: reproduzir, distribuir ou revender o conteúdo do BetModel; usar o serviço para fins ilegais; partilhar credenciais de acesso com terceiros; tentar aceder a sistemas não autorizados.</p>
        </div>

        <div>
          <h2 className="text-white font-bold text-base mb-2">6. Propriedade Intelectual</h2>
          <p>Todo o conteúdo, modelos e algoritmos do BetModel são propriedade exclusiva do BetModel. É proibida a reprodução sem autorização expressa.</p>
        </div>

        <div>
          <h2 className="text-white font-bold text-base mb-2">7. Limitação de Responsabilidade</h2>
          <p>O BetModel não garante a exatidão, completude ou utilidade das análises. Em nenhuma circunstância seremos responsáveis por danos indiretos, incidentais ou consequentes.</p>
        </div>

        <div>
          <h2 className="text-white font-bold text-base mb-2">8. Contacto</h2>
          <p>Para questões sobre estes termos, contacte: <span className="text-volt">formulário de contacto no site</span></p>
        </div>
      </section>
    </div>
  );
}
